import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { CreateTeamViewTopBar } from "./TopBar"

export const createTeamViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: CreateTeamViewTopBar,
}
